// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UserTotals } from "./UserTotals";
import {
  UserTotalsFromJSON,
  UserTotalsFromJSONTyped,
  UserTotalsToJSON,
  UserTotalsToJSONTyped,
} from "./UserTotals";

/**
 *
 * @export
 * @interface UserUsage
 */
export interface UserUsage {
  /**
   *
   */
  totals: UserTotals;
  /**
   *
   */
  projects?: { [key: string]: UserTotals };
}

/**
 * Check if a given object implements the UserUsage interface.
 */
export function instanceOfUserUsage(value: object): value is UserUsage {
  if (!("totals" in value) || value["totals"] === undefined) return false;
  return true;
}

export function UserUsageFromJSON(json: any): UserUsage {
  return UserUsageFromJSONTyped(json, false);
}

export function UserUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUsage {
  if (json == null) {
    return json;
  }
  return {
    totals: UserTotalsFromJSON(json["totals"]),
    projects:
      json["projects"] == null ? undefined : mapValues(json["projects"], UserTotalsFromJSON),
  };
}

export function UserUsageToJSON(json: any): UserUsage {
  return UserUsageToJSONTyped(json, false);
}

export function UserUsageToJSONTyped(
  value?: UserUsage | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    totals: UserTotalsToJSON(value["totals"]),
    projects:
      value["projects"] == null ? undefined : mapValues(value["projects"], UserTotalsToJSON),
  };
}
